import { render, staticRenderFns } from "./RoadmapNav.vue?vue&type=template&id=72b227a8&scoped=true"
import script from "./RoadmapNav.vue?vue&type=script&lang=js"
export * from "./RoadmapNav.vue?vue&type=script&lang=js"
import style0 from "./RoadmapNav.vue?vue&type=style&index=0&id=72b227a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b227a8",
  null
  
)

export default component.exports